var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-data-table", {
        staticClass: "edit-inline-data-table",
        attrs: {
          headers: _vm.headers,
          items: _vm.notifications,
          "hide-actions": ""
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function(props) {
              return [
                _c(
                  "td",
                  [
                    _c(
                      "v-edit-dialog",
                      {
                        attrs: {
                          "return-value": props.item.name,
                          lazy: "",
                          large: "",
                          light: ""
                        },
                        on: {
                          "update:returnValue": function($event) {
                            _vm.$set(props.item, "name", $event)
                          },
                          save: function($event) {
                            _vm.save(props.item)
                          },
                          cancel: _vm.cancel,
                          open: _vm.open,
                          close: _vm.close
                        }
                      },
                      [
                        _c("div", [_vm._v(_vm._s(props.item.name))]),
                        _vm._v(" "),
                        _c("v-textarea", {
                          attrs: {
                            slot: "input",
                            "auto-grow": "",
                            rows: "1",
                            "hide-details": "",
                            solo: "",
                            flat: ""
                          },
                          slot: "input",
                          model: {
                            value: props.item.name,
                            callback: function($$v) {
                              _vm.$set(props.item, "name", $$v)
                            },
                            expression: "props.item.name"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _c(
                      "v-edit-dialog",
                      {
                        attrs: {
                          "return-value": props.item.description,
                          lazy: "",
                          large: "",
                          light: ""
                        },
                        on: {
                          "update:returnValue": function($event) {
                            _vm.$set(props.item, "description", $event)
                          },
                          save: function($event) {
                            _vm.save(props.item)
                          },
                          cancel: _vm.cancel,
                          open: _vm.open,
                          close: _vm.close
                        }
                      },
                      [
                        _c("div", [_vm._v(_vm._s(props.item.description))]),
                        _vm._v(" "),
                        _c("v-textarea", {
                          attrs: {
                            slot: "input",
                            "auto-grow": "",
                            rows: "2",
                            "hide-details": "",
                            solo: "",
                            flat: ""
                          },
                          slot: "input",
                          model: {
                            value: props.item.description,
                            callback: function($$v) {
                              _vm.$set(props.item, "description", $$v)
                            },
                            expression: "props.item.description"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-center" }, [
                  _vm._v(_vm._s(props.item.type))
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-center" }, [
                  _vm._v(_vm._s(props.item.sub_type))
                ])
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: { timeout: 3000, color: _vm.snackColor },
          model: {
            value: _vm.snack,
            callback: function($$v) {
              _vm.snack = $$v
            },
            expression: "snack"
          }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.snackText) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { flat: "" },
              on: {
                click: function($event) {
                  _vm.snack = false
                }
              }
            },
            [_vm._v("Close")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a09884c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a09884c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/settings/settings-child-notification/template.html
// module id = null
// module chunks = 